/**
 * Display name for the signed-in DJ, read from the app JWT's claims. The API
 * puts firstName/lastName (or name/email) in the token, so no profile fetch
 * is needed.
 */
export const readUserLabel = (accessToken: string | null): string => {
  if (!accessToken) return '';
  try {
    const payload = JSON.parse(atob(accessToken.split('.')[1]));
    const fullName = [payload.firstName, payload.lastName]
      .filter(Boolean)
      .join(' ');
    return fullName || payload.name || payload.email || '';
  } catch {
    return '';
  }
};
